import React from 'react'
import './v3-data-routes.css'

interface V3DataRouteShellProps {
  children: React.ReactNode
}

export default function V3DataRouteShell({ children }: V3DataRouteShellProps) {
  return (
    <div className="v3-data-route py-6">
      <div className="mx-auto w-[95%] min-w-0">
        <div className="v3-data-route__content min-w-0">
          {children}
        </div>
      </div>
    </div>
  )
}

